import {Button, Form, Modal, Select, message, Spin} from "antd";
import React, {useEffect, useState} from "react";
import api from "../../api";

const DAYS_OF_WEEK = [
    {value: 0, label: 'Maandag'},
    {value: 1, label: 'Dinsdag'},
    {value: 2, label: 'Woensdag'},
    {value: 3, label: 'Donderdag'},
    {value: 4, label: 'Vrijdag'},
    {value: 5, label: 'Zaterdag'},
    {value: 6, label: 'Zondag'},
];

const TASK_TYPES = [
    {type: 'sow', label: 'Zaaien'},
    {type: 'prick', label: 'Verspenen'},
    {type: 'plant', label: 'Planten'},
    {type: 'harvest', label: 'Oogsten'},
];

export default function TaskSettingsModal({open, onCancel, onSuccess}) {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (open) {
            setIsLoading(true);
            api.getTaskDayPreferences().then(preferences => {
                // Convert array of preferences to form values
                const values = {};
                TASK_TYPES.forEach(taskType => {
                    const pref = preferences.find(p => p.task_type === taskType.type);
                    values[taskType.type] = pref ? pref.day_of_week : null;
                });
                form.setFieldsValue(values);
            }).catch(() => {
                message.error('Kon instellingen niet laden');
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }, [open, form]);

    function handleSubmit() {
        form.validateFields().then(values => {
            setIsSubmitting(true);

            // Convert form values to preferences array
            const preferences = TASK_TYPES.map(taskType => ({
                task_type: taskType.type,
                day_of_week: values[taskType.type]
            }));

            api.updateTaskDayPreferences(preferences).then(() => {
                message.success('Instellingen opgeslagen');
                if (onSuccess) onSuccess();
                onCancel();
            }).catch(() => {
                message.error('Er ging iets mis');
            }).finally(() => {
                setIsSubmitting(false);
            });
        });
    }

    return (
        <Modal
            title="Taak instellingen"
            open={open}
            onCancel={onCancel}
            footer={(
                <Button type="primary" onClick={handleSubmit} loading={isSubmitting}>
                    Opslaan
                </Button>
            )}
        >
            <p className="mar-b-1">
                Stel in op welke dag van de week je bepaalde taken wilt uitvoeren.
                Wanneer je een planting toevoegt, worden de taken automatisch gepland op deze dagen.
            </p>

            {isLoading ? (
                <div className="text-center pad-2">
                    <Spin />
                </div>
            ) : (
                <Form form={form} layout="vertical">
                    {TASK_TYPES.map(taskType => (
                        <Form.Item
                            key={taskType.type}
                            name={taskType.type}
                            label={taskType.label}
                        >
                            <Select
                                placeholder="Geen voorkeur"
                                allowClear
                                options={DAYS_OF_WEEK}
                            />
                        </Form.Item>
                    ))}
                </Form>
            )}
        </Modal>
    );
}
